module.exports = __webpack_public_path__ + "static/media/jammer.dab13055.svg";